module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.scss
// module id = ./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.scss
// module chunks = 0